import axios from 'axios';

let uploaderURL = '';

export const initUploaderService = (config: Record<string, any>) => {
    uploaderURL = config.uploaderURL;
};

export const postGlobalRules = (payload: any) => {
    return axios.post(`${uploaderURL}/global-rules`, payload);
};

export const postMerchantOverrides = (payload: any) => {
    return axios.post(`${uploaderURL}/merchant-overrides`, payload);
};

export const postGlobalRulesBulkUploadErrorCSV = (payload: { filename: string; errors: UploadErrorsType }) => {
    return axios.post(`${uploaderURL}/global-rules/export-errors`, payload);
};

export const postMerchantOverridesBulkUploadErrorCSV = (payload: { filename: string; errors: UploadErrorsType }) => {
    return axios.post(`${uploaderURL}/merchant-overrides/export-errors`, payload);
};
